export const currencyFormatter = (language: string = 'en', decimals: number = 0) =>
  new Intl.NumberFormat(language, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
